.root {
  display: inline-flex;
}

.filledIcon {
  fill: hsl(var(--primary));
  stroke: hsl(var(--primary));
}
